import { useTranslation } from 'react-i18next';

import MainTitle from '../common/MainTitle';
import Culture from '../../assets/images/careers/culture-and-environment.jpeg';
import CultureWebp from '../../assets/images/careers/culture-and-environment.webp';
import ImageLink from '../../js/utils/ImageLink';

/**
 *
 * @param {{ title1: string, title2: string, description: string, isReversed?: boolean }} props
 * @returns
 */

export default function CultureEnvironment({ title1, title2, description, image, isReversed }) {
  const { t } = useTranslation(['CareersPage']);

  return (
    <div className="culture">
      <section className={`culture-section container ${isReversed ? 'reversed' : ''}`}>
        <div className="culture-section__header mobile">
          <MainTitle type="dark" className="text--2xl">
            <span>{title1}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {title2}
            </span>
          </MainTitle>
        </div>

        <div className="culture-section__content">
          <div className="culture-section__header desktop">
            <MainTitle type="dark" className="text--2xl">
              <span>{title1}</span>
              <span className="decorated-line decorated-line--dark decorated-line--left">
                {title2}
              </span>
            </MainTitle>
          </div>
          <p>{description}</p>
        </div>

        <div className="culture-section__media">
          {image?.url && (
            <picture>
              <source srcSet={ImageLink(image?.url)} />
              <img src={ImageLink(image?.url)} alt={image?.alt} />
            </picture>
          )}
        </div>
      </section>
    </div>
  );
}
